/**
 * What a signed-in customer can read about the formula currently waiting for a physician. The
 * Worker loads it from the in-review version; the reviewing screen renders it. Names and doses are
 * already resolved, so the web app never has to reach the catalog.
 */
import { z } from "zod";

const StoredRationale = z.object({ sentence: z.string() });

/** The customer-facing sentence stored on a component, or empty when the JSON has none. */
export function sentenceOf(rationaleJson: string): string {
  let parsed: unknown;

  try {
    parsed = JSON.parse(rationaleJson);
  } catch {
    return "";
  }

  const read = StoredRationale.safeParse(parsed);

  return read.success ? read.data.sentence : "";
}

export interface FormulaLine {
  readonly ingredientId: string;
  readonly name: string;
  readonly dose: number;
  readonly unit: string;
  readonly separateAddon: boolean;
  /** The engine's one-sentence reason, empty when the stored rationale has none. */
  readonly sentence: string;
  readonly isProteinBase: boolean;
}

export interface CurrentFormula {
  readonly formulaVersionId: string;
  readonly version: number;
  readonly status: "in_review";
  readonly ingredients: readonly FormulaLine[];
}
